import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { CharlieButton } from '@ver.id/libs.ui.charlie';
import Spinner from '../../components/Spinner';
import { useTranslation } from '../../i18n/i18n';

type Props = {
  pairingCode: string;
  onCancel: () => void;
  onCompletePairing: () => void;
  onBack?: () => void;
};

export default function AppPairingContent({
  pairingCode,
  onCancel,
  onCompletePairing,
  onBack,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 items-center justify-center w-full">
      <div className="flex flex-col items-center gap-6 text-center max-w-lg w-full">
        <Spinner />
        <div>
          <h2 className="text-2xl font-semibold text-foreground">
            {t('pairing.title')}
          </h2>
          <p className="text-sm text-muted-foreground mt-2">
            {t('pairing.hint')}
          </p>
        </div>
        {pairingCode && (
          <div className="flex flex-col items-center gap-3">
            <p className="text-sm text-muted-foreground">
              {t('pairing.codeLabel')}
            </p>
            <span className="text-2xl font-mono font-bold tracking-widest text-foreground">
              {pairingCode}
            </span>
            <CharlieButton
              className="w-full max-w-xs"
              onClick={onCompletePairing}
            >
              {t('pairing.confirm')}
            </CharlieButton>
          </div>
        )}
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <FontAwesomeIcon icon={faArrowRightArrowLeft} className="size-4" />
            {t('agentStart.changeApp')}
          </button>
        )}
        <CharlieButton
          variant="outline"
          className="w-full max-w-xs"
          onClick={onCancel}
        >
          {t('agentStart.cancel')}
        </CharlieButton>
      </div>
    </div>
  );
}
